/**
 * Helper to fetch and add Classes worksheet to workbook
 */

import ExcelJS from "exceljs";

import { fetchAndBuildClassesData } from "./fetcher";
import { buildClassesWorksheet } from "./sheetBuilder";

import type { AxiosInstance } from "axios";
import type { Coverage } from "./builder";

export const addClassesWorksheet = async (
  workbook: ExcelJS.Workbook,
  ecoRfpId: string,
  coverages: Coverage[],
  axiosInstance: AxiosInstance,
): Promise<void> => {
  const classesRows = await fetchAndBuildClassesData(
    ecoRfpId,
    coverages,
    axiosInstance,
  );

  if (classesRows.length > 0) {
    buildClassesWorksheet(workbook, classesRows);
  }
};
